import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import RouterComponent from "./routes";

ReactDOM.render(
  <React.StrictMode>
    <RouterComponent />
  </React.StrictMode>,
  document.getElementById('root')
);

